export const InvoicesCardListingStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    rowGap: "20px",
  },
};
